import { FC } from 'react'
import { ClockInOutDetailsBase } from 'screens/Rostering/components/ClockInOutDetailBase'
import { ClockInOutAction } from 'screens/Rostering/hooks/useClockInOut'
import { ClockInLocation } from 'screens/Rostering/types'

type ClockOutDetailsProps = {
  time?: string
  note?: string
  location?: ClockInLocation
  openClockInOutModal: () => void
  warnings?: string[]
  action: ClockInOutAction
  isDeletedSU?: boolean
  timezone?: string
  publishedRota?: boolean
  showInvalidAddressForGeofencingWarning?: boolean
}

export const ClockOutDetails: FC<ClockOutDetailsProps> = (props) => (
  <ClockInOutDetailsBase {...props} type="out" />
)
